"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CJK_UNICODE_RANGES = void 0;
exports.CJK_UNICODE_RANGES = [
    [19968, 40959],
    [13312, 19903],
    [131072, 173791],
    [173824, 177983],
    [177984, 178207],
    [178208, 183983],
    [183984, 191471],
    [196608, 201551],
    [201552, 205743],
    [63744, 64255],
    [194560, 195103],
    [12032, 12255],
    [11904, 12031],
    [12288, 12351],
    [13056, 13311],
    [65072, 65103], // CJK Compatibility Forms                     FE30-FE4F
];
